import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('FarcanaDailyBonus').create(({ theme }) => ({
  separatorWrapper: {
    position: 'absolute',
    height: '143px',
    zIndex: 4,
    // position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  separatorLine: {
    position: 'relative',
    zIndex: 2,
    width: '8px',
    height: '45%',
    background: theme.colors.background.primary,
    border: '1px solid black',
    borderTop: 'none',
    borderBottom: 'none',
  },

  daysLabel: {
    position: 'relative',
    zIndex: '1',
    marginTop: '-1px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '48px',
    height: '36px',
    background: theme.colors.background.primary,
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.2), 0px 1px 0px 0px rgba(0, 0, 0, 1) inset',
    borderRadius: '24px',
    span: {
      fontSize: '12px',
      lineHeight: theme.sizes.texts.lineHeight.l,
      color: theme.colors.text.primary,

      fontWeight: 460,
    },
  },
}))
